import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/narutoData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg" />
          </span>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">
            火影同人集
          </span>
        </a>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              onClick={(e) => {
                e.preventDefault();
                scrollTo(l.key);
              }}
              className="text-sm font-medium text-foreground-600 transition-colors hover:text-primary-500 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#featured"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("featured");
            }}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即浏览
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-950"
          aria-label="打开菜单"
        >
          <i className={`ri-${open ? "close" : "menu"}-line text-2xl`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/60 bg-background-50/95 backdrop-blur-md">
          <div className="flex flex-col px-4 py-4">
            {navLinks.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(l.key);
                }}
                className="rounded-md px-3 py-3 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#featured"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("featured");
              }}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              立即浏览
            </a>
          </div>
        </div>
      )}
    </header>
  );
}